var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHackerRank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.925,
    height: 43,
    viewBox: "0 0 42.925 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.946,
    y1: 0.189,
    x2: 0.238,
    y2: 0.855,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b6bb20",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 21,
    ry: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 20,
    ry: 20.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5950.5-1440a19.372,19.372,0,0,1-13.789-5.711A19.373,19.373,0,0,1-5970-1459.5a19.373,19.373,0,0,1,5.711-13.789A19.373,19.373,0,0,1-5950.5-1479a19.373,19.373,0,0,1,13.789,5.711A19.373,19.373,0,0,1-5931-1459.5a19.373,19.373,0,0,1-5.711,13.789A19.372,19.372,0,0,1-5950.5-1440Zm0-29.465c-1.359,0-8.02,3.821-8.691,4.986s-.673,8.8,0,9.959,7.334,4.985,8.691,4.985,8.012-3.817,8.691-4.98.679-8.807,0-9.968S-5949.154-1469.465-5950.5-1469.465Zm0,18.388h0a29.13,29.13,0,0,1-7.355-4.214,28.979,28.979,0,0,1,0-8.417,29.04,29.04,0,0,1,7.355-4.213,29.264,29.264,0,0,1,7.358,4.213,28.664,28.664,0,0,1,0,8.416,29.146,29.146,0,0,1-7.358,4.216Zm.77-4.591,1.533,1.533,1.533-1.533h-.766v-6.9h-1.534v2.3h-3.065v-3.067h.767l-1.534-1.533-1.533,1.533h.767v7.665h1.533v-3.065h3.065v3.065Z",
    transform: "translate(5973.926 1483)",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackerRank);
export default __webpack_public_path__ + "static/media/HackerRank.d41857a626373bb6ac5a30322fb0544c.svg";
export { ForwardRef as ReactComponent };